/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var FilterOperator;

(function (FilterOperator) {
  FilterOperator["OR"] = "or";
  FilterOperator["AND"] = "and";
})(FilterOperator || (FilterOperator = {}));